import { CurrencyPipe, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ShopifyService } from 'src/app/service/shopify.service';

@Component({
  selector: 'app-conditional-upsell',
  standalone: true,
  imports: [NgFor, NgIf, CurrencyPipe, NgOptimizedImage],
  templateUrl: './conditional-upsell.component.html',
  styleUrl: './conditional-upsell.component.scss',
})
export class ConditionalUpsellComponent implements OnChanges {
  @Input() theme: any;
  @Input() cart: any;

  @Input() _upsell: any[] = [];
  constructor(private shopifyService: ShopifyService) {}

  ngOnChanges(): void {}

  addToCart(product: any) {
    this.shopifyService
      .addToCart([
        {
          variantId: 'gid://shopify/ProductVariant/' + product.variants[0].id,
          quantity: 1,
        },
      ])
      .subscribe((data) => {
        console.log(data);
      });
  }
}
